export default __webpack_public_path__ + "static/media/signinMinionNewHHLogo.bab1aa9f.svg";